// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"048a3b2b","292":"977029ba","324":"655c0082","453":"edd102e0","575":"73ffd62c","582":"3453eb79","593":"ce318153","652":"b6f24e29","683":"b7c521f8","722":"34d49770","834":"a2654be6","836":"ef212206","839":"fa27e150","859":"f3755d0e"}[chunkId] + ".chunk.js";
};